import { render, staticRenderFns } from "./TopicSection.vue?vue&type=template&id=5d991b10&scoped=true"
import script from "./TopicSection.vue?vue&type=script&lang=js"
export * from "./TopicSection.vue?vue&type=script&lang=js"
import style0 from "./TopicSection.vue?vue&type=style&index=0&id=5d991b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d991b10",
  null
  
)

export default component.exports